// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"877":"dad108b6","879":"275ae70e"}[chunkId] + ".chunk.js";
};